import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import Vant from 'vant'
import wx from 'weixin-js-sdk'

import 'vant/lib/index.css'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$wx = wx;

router.afterEach(route => {
  // 从路由的元信息中获取 title 属性
  if (route.meta.title) {
      document.title = route.meta.title;
      // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
      // if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      //     const hackIframe = document.createElement('iframe');
      //     hackIframe.style.display = 'none';
      //     hackIframe.src = './html/fixIosTitle.html?r=' + Math.random();
      //     document.body.appendChild(hackIframe);
      //     setTimeout(_ => {
      //         document.body.removeChild(hackIframe)
      //     }, 300)
      // }
  }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
